import React from 'react';

//MUI Component
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { Box, CircularProgress } from '@mui/material';

// Icons
import { DuplicateCIcon, ModalCrossCIcon } from '~/assets/images';
import OlcButton from '~/components/General/OlcButton';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const ConfirmDialog = ({
  handleClose,
  open,
  message,
  handleOk,
  loading,
  header,
  successButtonName,
  cancelButtonName,
}) => {
  return (
    <>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        className="autoFundModalWrapper"
      >
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 5,
            top: 5,
            padding: '0',
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <ModalCrossCIcon />
        </IconButton>
        <DialogContent className="autoFundModalContent">
          <img
            style={{
              height: '58px',
            }}
            src={DuplicateCIcon}
            alt="duplicate"
          />
          <Box className="autoFundHeader">
            <Typography gutterBottom variant="h4">
              {header}
            </Typography>
          </Box>
          <Box>
            <Typography>{message}</Typography>
          </Box>
          <Box className="autoFundModalBtns">
            <OlcButton variant="secondary" onClick={handleClose}>
              {cancelButtonName}
            </OlcButton>
            <OlcButton variant="primary" disabled={loading} onClick={handleOk}>
              {loading ? (
                <CircularProgress
                  sx={{
                    color: 'white',
                    width: '25px !important',
                    height: '25px !important',
                  }}
                />
              ) : successButtonName ? (
                successButtonName
              ) : (
                'Ok'
              )}
            </OlcButton>
          </Box>
        </DialogContent>
      </BootstrapDialog>
    </>
  );
};

export default ConfirmDialog;
